// This module saves a file to the user's computer
// In the future we can modify this to save more than just CSV files
function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

export default (data, fileName, format = 'csv') => {
  let blob = null;
  let type = 'text/csv;charset=utf-8;';
  if (format === 'xlsx') {
    blob = new Blob([(s2ab(atob(data)))], { type: 'application/vnd.openxmlformats' });
  }
  else {
    blob = new Blob([data], { type });
  }
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/downloadFile.js